import React from "react";
import AnimatedHeading from "../AnimatedHeading";
import { IMG } from "../../assetsBase";

const services = [
  {
    id: "digital",
    icon: "icon1.png",
    title: "Digital Solutions",
    description:
      "Modern software and immersive digital products that transform ideas into scalable solutions, from custom platforms to next-generation gaming and Web3 experiences.",
    highlights: [
      "Custom Software Development",
      "Web Application Development",
      "Mobile Game Development",
      "Virtual Reality (VR) Development",
      "Augmented Reality (AR) Development",
      "Web3 In-Game Services",
    ],
  },
  {
    id: "business",
    icon: "icon2.png",
    title: "Business Solutions",
    description:
      "Practical consulting and strategic support to improve performance, embrace innovation, and drive sustainable growth across your organization.",
    highlights: [
      "Business Development",
      "Digital Transformation",
      "Project Management",
      "Technical Advisory",
    ],
  },
  {
    id: "supply",
    icon: "icon3.png",
    title: "Supply & Trading Solutions",
    description:
      "Trusted sourcing, procurement, and international trading across regional and global markets, backed by a reliable supplier network.",
    highlights: [
      "Personal Wellness Products",
      "Procurement Services",
      "Import & Export",
      "Logistics Coordination",
      "International Trading",
    ],
  },
];

function Services() {
  return (
    <section
      className="orbia-service_one bg_cover pt-115 pb-120"
      id="services"
      style={{ backgroundImage: `url(${IMG}/bg/service-bg.jpg)` }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-10">
            <div className="section-title text-center text-white mb-45">
              <span
                className="sub-title"
                data-aos="fade-down"
                data-aos-duration="1000"
              >
                Our Best Services
              </span>
              <AnimatedHeading>
                Solutions Built Around Your Goals
              </AnimatedHeading>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          {services.map((service, index) => (
            <div
              className="col-xl-4 col-md-6 col-sm-12 item-column"
              id={service.id}
              key={service.id}
            >
              <div
                className={`orbia-service-card ${
                  index === 1 ? "item-active" : ""
                }`}
                data-aos="fade-up"
                data-aos-duration={800 + index * 200}
              >
                <div className="content">
                  <p>{service.description}</p>
                  <ul className="check-list gradient-check service-highlights">
                    {service.highlights.map((point) => (
                      <li key={point}>
                        <i className="fas fa-check-circle"></i>
                        {point}
                      </li>
                    ))}
                  </ul>
                  <div className="icon">
                    <img src={`${IMG}/icon/${service.icon}`} alt="icon" />
                  </div>
                  <h3 className="title">{service.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
